export default __webpack_public_path__ + "media/design-system/form/assets/small-cross-a15fcfbe10e6273a08b5b9c4c1902925.svg";